// extracted by mini-css-extract-plugin
module.exports = {"Performance":"Performance_Performance__wqwqC"};